import React, { useState, useImperativeHandle, useRef, forwardRef } from 'react';
import { FormGroup, Input, Select, PopOver, OverlayTrigger } from '@tencent/spaui';
import MultiUpload from '../components/MultiUpload';
import { APPTYPE, FINANCING } from '../const/constant';
import IndustrySelect from '../components/IndustrySelect';
import './info-common.scss';

const baseState = {
  service_industry: [] as Array<any>, // 主要服务行业
  business_cooperation_cert: '', // 产品商业化合作证明  上传文件地址，最多10个
  industry_customer_size: '', // 服务行业及客户数量
  financing: 0, // 是否融资
  financing_company: '', // 融资公司名称
  app_name: '', // 应用名称
  app_type: '', // 应用类型
  app_introduction: '', // 应用介绍
  service_case: '', // 服务案例/能力举证
  fees: '', // 收费标准
  attached_files: [] as Array<any>, // 其他补充资料
};

// const baseState = {
//   service_industry: [21474836482, 21474836486],
//   industry_customer_size: "23452345",
//   financing: 0,
//   app_name: '123',
//   app_type: 1,
//   business_cooperation_cert: [{
//     "url": "http://pgdt.gtimg.cn/gdt/0/95788d61141c4ec8bd533a6a77716787.IMG/0?ck=bfafcd488af790bff153f60e77d366e0",
//     "name": "123123.jpg",
//     "status": "success",
//     "file_name": "123123.jpg",
//     "file_url": "http://pgdt.gtimg.cn/gdt/0/95788d61141c4ec8bd533a6a77716787.IMG/0?ck=bfafcd488af790bff153f60e77d366e0"
//   },
//     {
//       "url": "http://pgdt.gtimg.cn/gdt/0/95788d61141c4ec8bd533a6a77716787.IMG/0?ck=bfafcd488af790bff153f60e77d366e0",
//       "name": "123123.jpg",
//       "status": "success",
//       "file_name": "123123.jpg",
//       "file_url": "http://pgdt.gtimg.cn/gdt/0/95788d61141c4ec8bd533a6a77716787.IMG/0?ck=bfafcd488af790bff153f60e77d366e0"
//     }
//   ],
//   app_introduction: [{
//     "url": "http://pgdt.gtimg.cn/gdt/0/95788d61141c4ec8bd533a6a77716787.IMG/0?ck=bfafcd488af790bff153f60e77d366e0",
//     "name": "123123.jpg",
//     "status": "success",
//     "file_name": "123123.jpg",
//     "file_url": "http://pgdt.gtimg.cn/gdt/0/95788d61141c4ec8bd533a6a77716787.IMG/0?ck=bfafcd488af790bff153f60e77d366e0"
//   }],
//   service_case: [{
//     "file_name": "123123.jpg",
//     "file_url": "http://pgdt.gtimg.cn/gdt/0/95788d61141c4ec8bd533a6a77716787.IMG/0?ck=bfafcd488af790bff153f60e77d366e0"
//   }], // 服务案例/能力举证
//   fees: [
//     {
//       "file_name": "123123.jpg",
//       "file_url": "http://pgdt.gtimg.cn/gdt/0/95788d61141c4ec8bd533a6a77716787.IMG/0?ck=bfafcd488af790bff153f60e77d366e0"
//     },
//   ], // 收费标准
// }

const FormExamStrateg: { [key: string]: any } = {
  // 主要服务行业
  service_industry: (value: any) => {
    if (!value || !value.length) {
      return '请选择主要服务行业';
    }
    if (value.length > 3) {
      return '最多选择三个行业';
    }
    return false;
  },
  // 商业化合作证明  上传文件地址，最多10个
  business_cooperation_cert: (value: any) => {
    if (!value || !value.length) {
      return '请选上传产品商业化合作证明';
    }
    if (value.every((item: { status: string }) => item.status === 'success')) {
      return false;
    }
    return '请上传产品商业化合作证明';
  },
  industry_customer_size: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length > 50) {
      return '长度过长';
    }
    return false;
  },
  financing_company: (value: any, formData: { financing: number }) => {
    if (formData.financing === 0) {
      return false;
    }
    if (!value) {
      return '不能为空';
    }
    if (value.length > 50) {
      return '长度过长';
    }
    return false;
  },
  app_name: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length < 2) {
      return '内容过短';
    }
    if (value.length > 50) {
      return '长度过长';
    }
    return false;
  },
  app_type: (value: any) => {
    if (value === '') {
      return '请选择应用类型';
    }
    return false;
  },
  // 应用介绍
  app_introduction: (value: any) => {
    if (!value || !value.length) {
      return '请上传应用介绍';
    }
    if (value.every((item: { status: string }) => item.status === 'success')) {
      return false;
    }
    return '请上传产应用介绍';
  },
  // 服务案例/能力举证
  service_case: (value: any) => {
    if (!value || !value.length) {
      return '请上传服务案例/能力举证';
    }
    if (value.every((item: { status: string }) => item.status === 'success')) {
      return false;
    }
    return '请上传产服务案例/能力举证';
  },
  // 收费标准
  fees: (value: any) => {
    if (!value || !value.length) {
      return '请上传收费标准';
    }
    if (value.every((item: { status: string }) => item.status === 'success')) {
      return false;
    }
    return '请上传收费标准';
  },
};

// const Feedback = (num: number, total: number) => (
//   <span>
//     <span className="spaui-input-feedback-count">{num}</span>
//     <span className="spaui-input-feedback-divider">/</span>
//     <span className="spaui-input-feedback-range">{total}</span>
//   </span>
// );

interface Props {
  children?: React.FunctionComponent<{ submit: () => void }>;
  onSubmit?: (data: any) => void;
  initData?: { [key: string]: any };
}

// 基本信息
// eslint-disable-next-line react/display-name
const BaseInfo: React.FC<Props> = forwardRef((props, cref) => {
  // 表单所有数据
  const [formData, setFormData] = useState<{ [key: string]: any }>({ ...baseState, ...props.initData });
  // 表单项检查
  const [formExam, setFormExam] = useState<{ [key: string]: any }>({});

  const setFormValue = (name: string, value: any) => {
    formData[name] = value;
    setFormData({ ...formData });
  };

  // 返回 true 代表表单正确
  const checkForm = (key: string): boolean => {
    const res = FormExamStrateg[key]?.(formData[key], formData);
    formExam[key] = res;
    setFormExam({ ...formExam });
    return !res;
  };

  const submit = () => {
    const result = Object.keys(FormExamStrateg).map((item) => checkForm(item));
    if (result.includes(false)) {
      return;
    }
    props.onSubmit?.(formData);
    return formData;
  };

  const Component = props.children;

  const contentRef = useRef();
  useImperativeHandle(cref, () => ({
    submit,
  }));

  return (
    <div ref={contentRef}>
      <div className="info-content">
        <div className="form-line">
          <span className="form-label">主要服务行业</span>
          <FormGroup className="form-item" error={formExam.service_industry}>
            <IndustrySelect
              value={formData.service_industry}
              onChange={(value: []) => {
                setFormValue('service_industry', value);
                checkForm('service_industry');
              }}
            />
          </FormGroup>
        </div>
        <div className="form-line">
          <span className="form-label">产品商业化合作证明</span>
          <OverlayTrigger
            trigger="hover"
            placement="top"
            overlay={<PopOver>与其他服务市场相关合作截图/合作证明相关文件（最多支持上传10 个文件）</PopOver>}
          >
            <FormGroup className="form-item" error={formExam.business_cooperation_cert}>
              <MultiUpload
                data={formData.business_cooperation_cert}
                max={10}
                onChange={(list) => {
                  setFormValue('business_cooperation_cert', list);
                  checkForm('business_cooperation_cert');
                }}
              />
            </FormGroup>
          </OverlayTrigger>
        </div>

        <div className="form-line">
          <span className="form-label">服务行业及客户数量</span>
          <FormGroup className="form-item" error={formExam.industry_customer_size}>
            <Input
              placeholder="请输入行业名称（客户数）；例：游戏（31）、电商（98）"
              value={formData.industry_customer_size}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('industry_customer_size', value.trim());
                checkForm('industry_customer_size');
              }}
              underlined
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">是否融资</span>
          <FormGroup className="form-item" error={formExam.financing}>
            <div className="form-item" style={{ display: 'flex' }}>
              <Select
                style={{ width: '100px' }}
                data={Object.keys(FINANCING).map((item) => ({ value: item, label: FINANCING[item] }))}
                value={formData.financing}
                onChange={(e: EventTarget, value: number) => {
                  if (+value === 0) {
                    setFormValue('financing_company', '');
                  }
                  setFormValue('financing', +value);
                }}
              />
              {+formData.financing === 1 && (
                <FormGroup style={{ flex: 1 }} error={formExam.financing_company}>
                  <Input
                    placeholder="请输入融资公司全称"
                    value={formData.financing_company}
                    onChange={(event: EventTarget, value = '') => {
                      setFormValue('financing_company', value.trim());
                      checkForm('financing_company');
                    }}
                    underlined
                  />
                </FormGroup>
              )}
            </div>
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">服务案例/能力举证</span>
          <OverlayTrigger
            trigger="hover"
            placement="top"
            overlay={<PopOver>需包括合作背景、合作过程、合作效果以及其他证明文件等（最多支持上传10个文件）</PopOver>}
          >
            <FormGroup className="form-item" error={formExam.service_case}>
              <MultiUpload
                data={formData.service_case}
                max={10}
                onChange={(list) => {
                  setFormValue('service_case', list);
                  checkForm('service_case');
                }}
              />
            </FormGroup>
          </OverlayTrigger>
        </div>

        <div className="form-line">
          <span className="form-label">收费标准</span>
          <OverlayTrigger
            trigger="hover"
            placement="top"
            overlay={<PopOver>请提交详细描述工具/服务的付费政策（最多支持上传10个文件）</PopOver>}
          >
            <FormGroup className="form-item" error={formExam.fees}>
              <MultiUpload
                data={formData.fees}
                max={10}
                onChange={(list) => {
                  setFormValue('fees', list);
                  checkForm('fees');
                }}
              />
            </FormGroup>
          </OverlayTrigger>
        </div>

        <div className="form-line">
          <span className="form-label">应用名称</span>
          <FormGroup
            className="form-item"
            error={formExam.app_name}
            // feedback={Feedback(formData['manager_name'].length, 20)}
          >
            <Input
              placeholder="请输入应用名称"
              value={formData.app_name}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('app_name', value.trim());
                checkForm('app_name');
              }}
              underlined
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">应用类型</span>
          <FormGroup className="form-item" error={formExam.app_type}>
            <Select
              value={formData.app_type}
              data={Object.keys(APPTYPE).map((item) => ({ value: item, label: APPTYPE[item] }))}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('app_type', +value);
                checkForm('app_type');
              }}
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">应用介绍</span>
          <OverlayTrigger
            trigger="hover"
            placement="top"
            overlay={<PopOver>合作应用的产品简介及相关文件（最多支持上传 10 个文件）</PopOver>}
          >
            <FormGroup className="form-item" error={formExam.app_introduction}>
              <MultiUpload
                data={formData.app_introduction}
                max={10}
                onChange={(list) => {
                  setFormValue('app_introduction', list);
                  checkForm('app_introduction');
                }}
              />
            </FormGroup>
          </OverlayTrigger>
        </div>

        <div className="form-line">
          <span className="form-label">其他补充资料</span>
          <OverlayTrigger
            trigger="hover"
            placement="top"
            overlay={<PopOver>其他补充资料（最多支持上传 10 个文件）</PopOver>}
          >
            <FormGroup className="form-item">
              <MultiUpload
                data={formData.attached_files}
                max={10}
                onChange={(list) => {
                  setFormValue('attached_files', list);
                }}
              />
            </FormGroup>
          </OverlayTrigger>
        </div>
      </div>
      <div style={{ display: 'inline-block' }}>{Component && <Component submit={submit} />}</div>
    </div>
  );
});

export default BaseInfo;
